import { AppEvent } from 'types/appEvent';
import { createReducer } from 'utils/reducer/reducerUtils';
import { PersonalInfoFormValues } from 'types/personalInfoTypes';

export const reduceToNextPersonalInfoFormValues = createReducer<
  PersonalInfoFormValues,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'ProdStackManager__PersonalInfoFormValuesChanged':
      return {
        ...prev,
        ...event.nextValues,
      };
    case 'ProdStackManager__PhoneConfirmed':
      return {
        ...prev,
        phone: event.phone,
      };
    default:
      return prev;
  }
});
